// Single shared source for the Tour & Ratio Planner's 6 categories — used identically by
// Edit Staff (Assigned Category), Schedule Tour (Category), and child grouping. Values match
// the canonical Child.category / Child.fullTimeSubcategory values in backend/models/child.py.
// Part Time is intentionally excluded — not used in the planner.
export const PLANNER_CATEGORIES = [
  { value: "infant", label: "Infant" },
  { value: "young_toddler", label: "Young Toddler" },
  { value: "older_toddler", label: "Older Toddler" },
  { value: "prek", label: "PreK" },
  { value: "school_age", label: "School Age" },
  { value: "after_school", label: "After School" },
];

// School Age and After School rooms are configured in months like every other room, but
// directors think of them in years, not months — shown spelled out everywhere a room's age
// range appears (Planner Settings room list, Live Ratios header).
export const formatAgeRange = (minAgeMonths, maxAgeMonths, category) => {
  if (category === "school_age" || category === "after_school") {
    return `${Math.round(minAgeMonths / 12)}-${Math.round(maxAgeMonths / 12)} years`;
  }
  return `${minAgeMonths}-${maxAgeMonths} months`;
};

